import React from "react";
import Input from "../../../../../Components/Input"; import Loader from "../../../../../Components/Loader";
import LoadingSkeleton from "../../../../../Components/LoadingSkeleton";
import InvoicePaymentGatewayController from "../../../../Controllers/AdminScreens/Invoices/Settings/InvoicePaymentGatewayController";
import TextInput from "../../../../../Components/TextInput";

const InvoicePaymentGatewayScreen = ({ paymentData, paymentLoading, paymentError, onRefresh }) => {
  const {
    pgApiKeyId,
    setPgApiKeyId,
    pgApiSecretKey,
    setPgApiSecretKey,
    saveLoading,
    saveError,
    success,
    savePaymentConfig,
    pgApiSecretKeyError,
    setPgApiSecretKeyError,
    pgApiKeyIdError,
    setPgApiKeyIdError,
    handleCancel,
    toggleShowApiKey,
    showPgApiKeyId,
    toggleShowApiSecretKey,
    showPgApiSecretKeyId,
  } = InvoicePaymentGatewayController(paymentData, paymentLoading, paymentError, onRefresh)

  return (
    <div className='basic-info-container' >
      <h3 className="tasksScreen-tasks-title" style={{ paddingBottom: 20, fontFamily: 'Roboto Slab' }}>Payment Configuration</h3>
      {paymentLoading ? (
        <div style={{ display: 'flex', gap: '80px' }}>
          <div>
            <label style={styles.label}>Payment Api Key</label>
            <div style={{ marginTop: 10 }}>
              <LoadingSkeleton width="150%" height="15px" />
            </div>
          </div>
          <div>
            <label style={styles.label}>Payment Secret Key</label>
            <div style={{ marginTop: 10 }}>
              <LoadingSkeleton width="150%" height="15px" />
            </div>
          </div>
        </div>
      ) : (
        <div className="tasksScreen-filters" style={{ display: 'flex' }}>
          <div style={{ marginTop: '-5px' }}>
            <label style={styles.label}>Payment Api Key</label>
            <TextInput
              label="Payment Api Key"
              placeholder="Enter Payment Api Key"
              value={pgApiKeyId}
              onChange={(e) => { setPgApiKeyId(e.target.value); setPgApiKeyIdError('') }}
              type={showPgApiKeyId ? 'text' : 'password'}
              errorMessage={pgApiKeyIdError}
              searchBoxWidth={220}
              right={
                <button onClick={toggleShowApiKey} className="toggle-button">
                  {showPgApiKeyId ? (
                    <img src={require('../../../../../Assets/Icons/Eye off.png')} alt="Hide " style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                  ) : (
                    <img src={require('../../../../../Assets/Icons/Eye-2.png')} alt="Show " style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                  )}
                </button>
              }
            />
          </div>
          <div style={{ marginTop: '-5px' }}>
            <label style={styles.label}>Payment Secret Key</label>
            <TextInput
              label="Payment Secret Key"
              placeholder="Enter Payment Secret Key"
              value={pgApiSecretKey}
              onChange={(e) => { setPgApiSecretKey(e.target.value); setPgApiSecretKeyError('') }}
              type={showPgApiSecretKeyId ? 'text' : 'password'}
              errorMessage={pgApiSecretKeyError}
              searchBoxWidth={220}
              right={
                <button onClick={toggleShowApiSecretKey} className="toggle-button">
                  {showPgApiSecretKeyId ? (
                    <img src={require('../../../../../Assets/Icons/Eye off.png')} alt="Hide " style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                  ) : (
                    <img src={require('../../../../../Assets/Icons/Eye-2.png')} alt="Show " style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                  )}
                </button>
              }
            />
          </div>
        </div>
      )}
      <div className="button-container" style={{ marginTop: '25px' }} >
        {saveError && <div className="list-error-msg" style={{ padding: 0 }}> {saveError}</div>}
        {success && <div className="list-success-msg" style={{ padding: 0 }}> {success}</div>}
      </div>
      <div className="button-container" style={{ marginBottom: '30px', }} >
        <button className="add-client-button" style={{ marginRight: '8px', paddingLeft: '30px', paddingRight: '30px', opacity: saveLoading || paymentLoading ? 0.5 : 1 }} onClick={savePaymentConfig} disabled={saveLoading || paymentLoading}>
          {(saveLoading || paymentLoading) &&
            <span style={{ paddingRight: 5 }} ><Loader loading={saveLoading || paymentLoading} color={'var(--background-color)'} size="small" /> </span>
          }{paymentData ? "Update" : "Add"}</button>
        <button className="cancel-button" onClick={handleCancel}>Cancel</button>
      </div>
    </div>
  )

}

export default InvoicePaymentGatewayScreen;

const styles = {
  label: {
    fontSize: '12px',
    color: '#343C44',
    fontWeight: 400,
    fontFamily: 'Roboto'
  },
};
